import { useDeviceType } from '@cian/ui-kit';
import React from 'react';
import { useSelector } from 'react-redux';

import { CustomerRoleSection } from '../../components/CustomerRoleSection';
import { selectDealSaleB2bPromoUrl } from '../../selectors/links';

export const CustomerRoleSectionContainer = () => {
  const b2bPromoUrl = useSelector(selectDealSaleB2bPromoUrl);
  const deviceType = useDeviceType();

  return <CustomerRoleSection b2bPromoUrl={b2bPromoUrl} deviceType={deviceType} />;
};
